class RecaptchaUtil {
	static load() {
		const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

		if (!siteKey) {
			console.error("Missing REACT_APP_RECAPTCHA_SITE_KEY");
			return;
		}

		const script = document.createElement("script");
		script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
		document.body.appendChild(script);

		return script;
	}

	static cleanUp(script) {
		// Remove reCAPTCHA script:
		if (script && script instanceof Node) {
			document.body.removeChild(script);
		}

		// Remove reCAPTCHA badge:
		const badge = document.querySelector(".grecaptcha-badge");
		if (badge) badge.remove();

		// Remove reCAPTCHA iframes:
		document.querySelectorAll("iframe[src*='recaptcha']").forEach((iframe) => iframe.remove());
	}

	static async execute(action) {
		if (!window.grecaptcha) {
			console.error("reCAPTCHA not loaded");
			return null;
		}

		try {
			return await window.grecaptcha.execute(process.env.REACT_APP_RECAPTCHA_SITE_KEY, {action});
		} catch (err) {
			console.error("Failed to execute reCAPTCHA:", err);
			return null;
		}
	}
}

export default RecaptchaUtil;
